import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  InvalidSemantic_getInstance19jq406epp0mv as InvalidSemantic_getInstance,
  ErrorSemantic_getInstanceqmizdq1y2zzq as ErrorSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../models/Theme.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../views/themeDerivations.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function validates(_this__u8e3s4, validates, validatesWhen) {
  var tmp;
  if (validatesWhen === VOID) {
    tmp = validates$lambda;
  } else {
    tmp = validatesWhen;
  }
  validatesWhen = tmp;
  dynamicTheme(_this__u8e3s4, ($this$dynamicTheme) => {
    var tmp;
    var tmp_0;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (validatesWhen($this$dynamicTheme)) {
      var tmp0 = validates;
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.any' call
        var inductionVariable = 0;
        var last = tmp0.length;
        while (inductionVariable < last) {
          var element = tmp0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this$dynamicTheme.baj(get_issues(element)).i1()) {
            tmp$ret$3 = true;
            break $l$block;
          }
        }
        tmp$ret$3 = false;
      }
      tmp_0 = tmp$ret$3;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = InvalidSemantic_getInstance();
    } else {
      tmp = null;
    }
    return tmp;
  });
}
function issueText(_this__u8e3s4, issues, transform, shownWhen_0) {
  var tmp;
  if (transform === VOID) {
    tmp = issueText$lambda;
  } else {
    tmp = transform;
  }
  transform = tmp;
  var tmp_0;
  if (shownWhen_0 === VOID) {
    tmp_0 = issueText$lambda_0;
  } else {
    tmp_0 = shownWhen_0;
  }
  shownWhen_0 = tmp_0;
  var tmp_1 = _this__u8e3s4.ibb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (shownWhen_0($this$shownWhen)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$shownWhen.baj(issues).i1();
    } else {
      tmp = false;
    }
    return tmp;
  }), _this__u8e3s4.hbb(ErrorSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$2 = joinToString($this$reactiveScope.baj(issues), '\n', VOID, VOID, VOID, VOID, transform);
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp_1, view);
}
function validates$lambda(_this__u8e3s4) {
  return true;
}
function issueText$lambda(it) {
  return it.iat();
}
function issueText$lambda_0(_this__u8e3s4) {
  return true;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
//region block: exports
export {
  issueText as issueText2dqtp9rg036jt,
  validates as validates376qnagkfv6he,
};
//endregion

//# sourceMappingURL=validation.mjs.map
